/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceTabletPin = createReactComponent(
  "device-tablet-pin",
  "IconDeviceTabletPin",
  [
    [
      "path",
      {
        d: "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7",
        key: "svg-0"
      }
    ],
    ["path", { d: "M12 16a1 1 0 0 0 0 2", key: "svg-1" }],
    [
      "path",
      {
        d: "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
        key: "svg-2"
      }
    ],
    ["path", { d: "M19 18v.01", key: "svg-3" }]
  ]
);

export { IconDeviceTabletPin as default };
//# sourceMappingURL=IconDeviceTabletPin.js.map
